import { useState, useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { MantineProvider } from '@mantine/core';
import { Notifications } from '@mantine/notifications';
import { ModalsProvider } from '@mantine/modals';
import { Provider } from 'react-redux';
import { store } from '@store/store';
import AppRoutes from './routes';

// Import styles in the correct order
import '@mantine/core/styles.css';
import '@mantine/notifications/styles.css';
import './styles/index.scss';

/* eslint-disable no-undef */
declare global {
  interface Window {
    localStorage: Storage;
  }
}
/* eslint-enable no-undef */

const App = () => {
  /* eslint-disable no-undef */
  const [isDark, setIsDark] = useState(window.localStorage.getItem('theme') === 'dark');

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', isDark ? 'dark' : 'light');
  }, [isDark]);

  const toggleTheme = () => {
    const nextTheme = isDark ? 'light' : 'dark';
    setIsDark(!isDark);
    window.localStorage.setItem('theme', nextTheme);
  };
  /* eslint-enable no-undef */

  return (
    <Provider store={store}>
      <BrowserRouter>
        <MantineProvider defaultColorScheme={isDark ? 'dark' : 'light'}>
          <ModalsProvider>
            <Notifications position="top-right" zIndex={1000} />
            <AppRoutes onThemeToggle={toggleTheme} isDark={isDark} />
          </ModalsProvider>
        </MantineProvider>
      </BrowserRouter>
    </Provider>
  );
};

export default App;
